import { DataFormProps } from './index';
import { DynamicPageProps } from 'types/DynamicPageProps';
import { SelectInputItemProps } from 'types/SelectInputItemProps';

export function verifyIfFormCanSave(
	dataForm: DataFormProps,
	setCanSaveModuleOnBack: React.Dispatch<React.SetStateAction<boolean>>,
	setMessageErrorForm: React.Dispatch<React.SetStateAction<string>>
) {
	if (dataForm.title === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Preenha o campo "Título"');
		return;
	}

	if (dataForm.banner.redirect.type === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Preenha o campo "Tipo de redirecionamento"');
		return;
	}

	if (dataForm.banner.redirect.value === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Preenha o campo "Valor do redirecionamento"');
		return;
	}

	if (dataForm.banner.title === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Preenha o campo "Título do banner"');
		return;
	}

	if (
		dataForm.banner.image.id === '' &&
		dataForm.banner.image.relativePath === ''
	) {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Suba a imagem do banner');
		return;
	}

	setCanSaveModuleOnBack(true);
}

export function returListOptionsDynamicPage(
	listPages: DynamicPageProps[]
): SelectInputItemProps[] {
	const listOptions: SelectInputItemProps[] = [];

	listPages.forEach((item) => {
		listOptions.push({ id: item.id, option: item.name });
	});

	return listOptions;
}
